import { render, staticRenderFns } from "./CribPlan.vue?vue&type=template&id=1d85e286&scoped=true"
import script from "./CribPlan.vue?vue&type=script&lang=ts"
export * from "./CribPlan.vue?vue&type=script&lang=ts"
import style0 from "./CribPlan.vue?vue&type=style&index=0&id=1d85e286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d85e286",
  null
  
)

export default component.exports